var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KeychainSwapApi } from '@api/keychain-swap';
import { BaseCurrencies } from '@popup/steem/utils/currency.utils';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import TokensUtils from '@popup/steem/utils/tokens.utils';
import TransferUtils from '@popup/steem/utils/transfer.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Asset as CommonAsset, SwapStatus, } from '@steempro/steem-keychain-commons';
import FormatUtils from 'src/utils/format.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import Logger from 'src/utils/logger.utils';
const getSwapTokenStartList = (account) => __awaiter(void 0, void 0, void 0, function* () {
    let userTokenList = [];
    // = await TokensUtils.getUserBalance(
    //   account.name,
    // );
    // userTokenList = userTokenList.filter(
    //   (token) => parseFloat(token.balance) > 0,
    // );
    // userTokenList = userTokenList.sort((a, b) =>
    //   b.symbol.toLowerCase() > a.symbol.toLowerCase() ? -1 : 1,
    // );
    if (CommonAsset.fromString(account.balance.toString()).amount > 0) {
        userTokenList.unshift({
            account: account.name,
            balance: CommonAsset.fromString(account.balance.toString()).amount.toString(),
            symbol: BaseCurrencies.STEEM.toUpperCase(),
        });
    }
    if (CommonAsset.fromString(account.sbd_balance.toString()).amount > 0) {
        userTokenList.unshift({
            account: account.name,
            balance: CommonAsset.fromString(account.sbd_balance.toString()).amount.toString(),
            symbol: BaseCurrencies.SBD.toUpperCase(),
        });
    }
    return userTokenList;
});
const getEstimate = (startToken, endToken, amount, handleErrors) => __awaiter(void 0, void 0, void 0, function* () {
    if (startToken && endToken && amount.length && parseFloat(amount) > 0) {
        const res = yield SteemTxUtils.getData(`condenser_api.get_ticker`, []);
        if (!res) {
            handleErrors();
            throw 'Something went wrong';
        }
        return res;
    }
});
const saveEstimate = (steps, slipperage, startToken, endToken, amount, username, partnerFee, partnerUsername) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield KeychainSwapApi.post(`token-swap/estimate/save`, {
        slipperage,
        steps,
        startToken,
        endToken,
        amount,
        username,
        partnerFee,
        partnerUsername,
    });
    if (response.error) {
        throw response.error;
    }
    else {
        return response.result.estimateId;
    }
});
const processSwap = (estimateId, startToken, amount, activeAccount, swapAccount, options) => __awaiter(void 0, void 0, void 0, function* () {
    if (startToken === BaseCurrencies.SBD.toUpperCase() ||
        startToken === BaseCurrencies.STEEM.toUpperCase()) {
        const status = yield TransferUtils.sendTransfer(activeAccount.name, swapAccount, `${amount.toFixed(3)} ${startToken}`, estimateId, activeAccount.keys.active, options);
        return status;
    }
    else {
        const tokenInfo = yield TokensUtils.getTokenInfo(startToken);
        const status = yield TokensUtils.sendToken(startToken, swapAccount, `${amount.toFixed(tokenInfo.precision)}`, estimateId, activeAccount.keys.active, activeAccount.name, options);
        return status;
    }
});
const retrieveSwapHistory = (username) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const res = yield KeychainSwapApi.get(`token-swap/history/${username}`);
    if (res.error) {
        return [];
    }
    const swaps = [];
    for (const s of res.result) {
        // const precisionStartToken = await TokensUtils.getTokenPrecision(
        //   s.startToken,
        // );
        // const precisionEndToken = await TokensUtils.getTokenPrecision(s.endToken);
        if (s.status === SwapStatus.PENDING && !s.transferInitiated)
            continue;
        swaps.push(Object.assign(Object.assign({}, s), { amount: FormatUtils.withCommas(Number(s.amount).toString(), 3, true), received: s.received &&
                FormatUtils.withCommas(Number(s.received).toString(), 3, true), finalAmount: FormatUtils.withCommas(Number((_a = s.received) !== null && _a !== void 0 ? _a : s.expectedAmountAfterFee).toString(), 3, true) }));
    }
    return swaps;
});
const cancelSwap = (swapId) => __awaiter(void 0, void 0, void 0, function* () {
    yield KeychainSwapApi.post(`token-swap/${swapId}/cancel`, {});
});
const getServerStatus = () => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield SteemTxUtils.getData(`condenser_api.get_ticker`, []);
    return {
        isMaintenanceOn: !(res === null || res === void 0 ? void 0 : res.latest),
        isServerStopped: !(res === null || res === void 0 ? void 0 : res.latest),
        layerTwoDelayed: !(res === null || res === void 0 ? void 0 : res.latest),
    };
});
const getConfig = () => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield KeychainSwapApi.get(`token-swap/public-config`);
    return res.result;
});
const saveLastUsed = (from, to) => __awaiter(void 0, void 0, void 0, function* () {
    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.SWAP_LAST_USED_TOKENS, { from, to });
});
const getLastUsed = () => __awaiter(void 0, void 0, void 0, function* () {
    const lastUsed = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.SWAP_LAST_USED_TOKENS);
    if (!lastUsed)
        return { from: null, to: null };
    else
        return lastUsed;
});
const setAsInitiated = (swapId) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield KeychainSwapApi.post(`token-swap/${swapId}/confirm`, {});
    if (!res.result) {
        Logger.error(`Couldn't set as initiated`);
    }
});
export const SwapTokenUtils = {
    getSwapTokenStartList,
    processSwap,
    getEstimate,
    saveEstimate,
    retrieveSwapHistory,
    cancelSwap,
    getServerStatus,
    getConfig,
    saveLastUsed,
    getLastUsed,
    setAsInitiated,
};
